import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import {
  ProgramDetailsContainer,
  Basics,
  LeftSection,
  RightSection,
  TooltipContainer,
} from "./styles";
import debounce from "lodash/debounce";
import {
  createInitialValid,
  updateValid,
  validateText,
} from "../../../../../common/utils";
import Labelize from "../../../../../common/Labelize";
import TextInput from "../../../../../common/TextInput";
import { ButtonSpacer } from "../../../../../common/Button/styles";
import Checkbox from "../../../../../common/Checkbox";
import features from "../../../../../config/features";
import ImageUpload from "../../../../../common/ImageUpload";
import Pills from "../../../../../common/Pills";
import { MultipleChoiceInput } from "../../popups/ApplicationModal/styles";
import callAPI from "../../../../../api/apiCaller";
import { Context } from "../../../../../Store";
import {
  MultipleChoiceLabel,
  MultipleChoiceOuter,
  MultipleChoiceContainer,
} from "../../ProgramContent/ProgramSurveys/styles";
import { ErrorMessage } from "../CreateFlowProgramManager/styles";
// import Tooltip from "../../../../../common/Tooltip";
import Tooltip from "./Tooltip";

function ProgramDetails({
  programForm,
  setProgramForm,
  isValid,
  setIsValid,
  isEditProgram,
  setProgramType,
  Image,
  programImage,
  setProgramNameExists,
  programNameExists,
}) {
  const { dispatch } = useContext(Context);
  const [refresh, setRefresh] = useState(false);
  const [programName, setProgramName] = useState("");

  function updateField(field) {
    return function (newValue) {
      setProgramForm({
        ...programForm,
        [field]: newValue,
      });
      setRefresh(!refresh);
    };
  }

  const useDebouncedCheckProgramName = (dispatch) => {
    const debouncedRef = useRef(null);

    const checkProgramNameExist = useCallback(
      (value) =>
        new Promise((resolve) => {
          if (debouncedRef.current) debouncedRef.current.cancel();

          debouncedRef.current = debounce(async () => {
            try {
              const res = await callAPI(dispatch, "searchProgramName", {
                programName: value,
              });
              if (res?.data?.title) {
                setProgramNameExists(true);
                setProgramName(res?.data?.title);
                resolve(false);
              } else {
                setProgramNameExists(false);
                setProgramName("");
                resolve(true);
              }
            } catch {
              resolve(false);
            }
          }, 200);

          debouncedRef.current(value);
        }),
      [dispatch]
    );

    return checkProgramNameExist;
  };

  const checkProgramNameExist = useDebouncedCheckProgramName(dispatch);

  useEffect(() => {
    setIsValid({
      title: !programNameExists && !!programForm.title,
      description: !!programForm.description,
      organization: !!programForm.organization,
      image: !!programForm.image,
    });
  }, [refresh]);

  const options = [
    {
      label: "1 - 1 Networking",
      value: "1_1_NETWORK",
      //dummy text
      tooltip:
        "Coordinator facilitates matches. Each mentee is paired with a dedicated mentor for personalized guidance.",
    },
    {
      label: "Open Networking",
      value: "OPEN_NETWORK",
      //dummy text
      tooltip:
        "Mentees request meetings with any available mentor in the program.",
    },
    {
      label: "Team",
      value: "TEAM",
      //dummy text
      tooltip:
        "Participants are grouped into small teams led by a designated lead mentor.",
    },
  ];

  return (
    <ProgramDetailsContainer>
      <Basics>
        <LeftSection>
          <Labelize label="Name" isMeetingRequest={true}>
            <TextInput
              value={programForm.title}
              maxWidth={"100%"}
              backgroundColor={"transparent"}
              placeholder="Program Name"
              setValue={updateField("title")}
              checkProgramNameExist={checkProgramNameExist}
              isValid={isValid.title}
              validator={validateText}
              setIsValid={(newValid) => {
                setIsValid({ ...isValid, title: true });
                updateValid(isValid, setIsValid, "title")(newValid);
              }}
            />
            {programNameExists && (
              <ErrorMessage>Program name already exists.</ErrorMessage>
            )}
          </Labelize>
          <Labelize label="Organization" isMeetingRequest={true}>
            <TextInput
              value={programForm.organization}
              maxWidth={"100%"}
              backgroundColor={"transparent"}
              placeholder="Program organization"
              setValue={updateField("organization")}
              isValid={isValid.organization}
              validator={validateText}
              setIsValid={updateValid(isValid, setIsValid, "organization")}
            />
          </Labelize>
          <Labelize label="About" isMeetingRequest={true}>
            <TextInput
              value={programForm.description}
              placeholder="About the Program"
              isEditProgram={true}
              setValue={updateField("description")}
              isValid={isValid.description}
              isTextArea={true}
              isHeight={true}
              wordLimit={500}
              validator={validateText}
              setIsValid={updateValid(isValid, setIsValid, "description")}
            />
          </Labelize>
        </LeftSection>
        <RightSection>
          <ImageUpload
            label={"png and jpg image only"}
            size={"100%"}
            setUploadIcon={"uploadIcon"}
            setSize={"1/1"}
            borderRadius={"0"}
            imageKey={(imageKey) => Image(imageKey)}
            value={programImage ? programImage : programForm.image}
            setValue={updateField("image")}
            setIsValid={(newValid) => {
              setIsValid({ ...isValid, image: true });
              updateValid(isValid, setIsValid, "image")(newValid);
            }}
          />
        </RightSection>
      </Basics>
      {!isEditProgram ? (
        <Labelize label="Program" isMeetingRequest={true}>
          <MultipleChoiceOuter>
            {options.map((option, i) => (
              <MultipleChoiceContainer>
                <MultipleChoiceLabel key={i} radioStyleType={true}>
                  <MultipleChoiceInput
                    radioStyleType={true}
                    type="radio"
                    name="programType"
                    value={programForm.programType}
                    checked={programForm.programType === option.value}
                    onChange={() => updateField("programType")(option.value)}
                  />
                  {option.label}
                </MultipleChoiceLabel>

                <TooltipContainer>
                  <Tooltip text={option?.tooltip} />
                </TooltipContainer>
              </MultipleChoiceContainer>
            ))}
          </MultipleChoiceOuter>
        </Labelize>
      ) : (
        ""
      )}

      {features.selfService && (
        <>
          <Checkbox
            label="Allow mentees to choose their mentors"
            value={programForm.type === "selfservice"}
            setValue={(newValue) => {
              setProgramForm({
                ...programForm,
                type: newValue ? "selfservice" : "fullservice",
              });
            }}
          />
          <ButtonSpacer />
        </>
      )}
    </ProgramDetailsContainer>
  );
}
export default ProgramDetails;
